import { render, staticRenderFns } from "./HistoryTransaction.vue?vue&type=template&id=70ad7061"
import script from "./HistoryTransaction.vue?vue&type=script&lang=js"
export * from "./HistoryTransaction.vue?vue&type=script&lang=js"
import style0 from "./HistoryTransaction.vue?vue&type=style&index=0&id=70ad7061&prod&lang=css"
import style1 from "spinkit/scss/spinkit.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports